import { useEffect } from "react";
import { useEditorStore } from "@/store";
import { readStyleFile } from "@/lib/fileIO";

/**
 * Registers a global drag-and-drop handler for .json files.
 * Uses loadNewStyle to fully reset state.
 */
export function useFileDropZone() {
  const loadNewStyle = useEditorStore((s) => s.loadNewStyle);

  useEffect(() => {
    const handleDragOver = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
    };

    const handleDrop = async (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const file = e.dataTransfer?.files[0];
      if (!file || !file.name.endsWith(".json")) return;

      try {
        const { style } = await readStyleFile(file);
        loadNewStyle(style);
      } catch (err) {
        console.error("Failed to load dropped file:", err);
      }
    };

    window.addEventListener("dragover", handleDragOver);
    window.addEventListener("drop", handleDrop);
    return () => {
      window.removeEventListener("dragover", handleDragOver);
      window.removeEventListener("drop", handleDrop);
    };
  }, [loadNewStyle]);
}
